module.exports = __webpack_public_path__ + "img/food.27aa0514.jpeg";